export default "__VITE_PUBLIC_ASSET__a1fff994__"